import React from 'react';

class VariantSelector extends React.Component { 
  handleSelect = (event) => {
    this.props.changeVariant( this.props.variants[event.target.selectedIndex].id )
  }

  multipleSelect = () => {
    return (
      <select ref={el => $(el).sexyDrop()} value={this.props.title} onChange={this.handleSelect} style={{fontSize: '16px', width: '100%'}}>  
        {this.props.variants.map((variant) =>
          <option key={variant.id}>{variant.title}</option>
        )}
      </select> 
    )
  }

  render() {
    let select;
    if (this.props.variants.length <= 1) {
      select = <div>{this.props.title}</div>
    } else {
      select = this.multipleSelect()
    }
    return select;
  }
}

export default VariantSelector;